var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfiguration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 64 64",
    style: {
      stroke: "currentColor",
      fill: "currentColor"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5,31.25H45.17a5.06,5.06,0,0,0-10,0H14.5a.75.75,0,0,0,0,1.5H35.15a5.06,5.06,0,0,0,10,0H49.5a.75.75,0,0,0,0-1.5Zm-9.34,4.34A3.59,3.59,0,1,1,43.75,32,3.59,3.59,0,0,1,40.16,35.59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,20.25h3.82a5.06,5.06,0,0,0,10,0H49.5a.75.75,0,0,0,0-1.5H28.34a5.06,5.06,0,0,0-10,0H14.5a.75.75,0,0,0,0,1.5Zm8.83-4.34a3.59,3.59,0,1,1-3.59,3.59A3.58,3.58,0,0,1,23.33,15.91Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5,43.75H33.89a5.06,5.06,0,0,0-10,0H14.5a.75.75,0,0,0,0,1.5h9.37a5.06,5.06,0,0,0,10,0H49.5a.75.75,0,0,0,0-1.5ZM28.88,48.09a3.59,3.59,0,1,1,3.58-3.59A3.59,3.59,0,0,1,28.88,48.09Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32,60.75A28.75,28.75,0,1,1,60.75,32,28.79,28.79,0,0,1,32,60.75Zm0-56A27.25,27.25,0,1,0,59.25,32,27.28,27.28,0,0,0,32,4.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguration);
export default __webpack_public_path__ + "static/media/configuration.f5c1b9a18c19f2d42232e45b8ff19d41.svg";
export { ForwardRef as ReactComponent };